<div class="welcome d-flex flex-column justify-content-center align-items-center">
    <div class="logo">
        <img src="images/newLogo.jpg" alt="logo" class="rounded-circle">
    </div>
    <div class="loading d-flex">
        <!-- <mat-spinner></mat-spinner> -->
        <span>Loading...</span>
    </div>
</div>
